import utils from 'utils'
import '../../assets/less1/print.css'
import statisticsDrawBackPage from './view/statisticsDrawBack.html'

export default function statisticsDrawBack(
  httpRequest,
  logger,
  $timeout,
  sweetalert,
  $uibModal,
  operationService
) {
  return {
    restrict: 'E',
    template: statisticsDrawBackPage,
    link(scope) {
      if (!operationService.hasPermit('drawback_statistics')) {
        return
      }
      const inputDeviceType =
        (localStorage.inputDeviceType &&
          JSON.parse(localStorage.getItem('inputDeviceType'))) ||
        {}
      httpRequest.get_getIsDrawbackEnterprises().then((res) => {
        if (res.data.success) {
          utils.loading('处理中')
          httpRequest
            .get_qryOrgTaxPeriod(
              JSON.parse(localStorage.user_info).user.currentOrgId
            )
            .then(
              (res) => {
                const response = res.data.value || {}
                scope.currentTaxPeriod = response.periodCode
                  ? response.periodCode.substring(0, 4) +
                    '-' +
                    response.periodCode.substring(4)
                  : null
                scope.expireTime = response.expireTime
                scope.periodName = response.periodName
                scope.taxPeriod = scope.currentTaxPeriod
              },
              () => {
                utils.loaded()
              }
            )
            .finally(() => {
              if (!scope.currentTaxPeriod) {
                logger.logError(
                  '未获取当前机构税款所属期，请确认电子底账采集任务已经执行'
                )
              }
              $timeout(() => {
                $('#taxPeriod').datetimepicker({
                  autoclose: true,
                  startView: 'year',
                  minView: 'year',
                  language: 'zh-CN',
                  format: 'yyyy-mm',
                  forceParse: 0,
                  pickTime: false,
                  pickerPosition: 'bottom-right',
                  endDate: scope.currentTaxPeriod,
                })
              })
            })
        } else {
          logger.logError(res.data.message)
        }
      })

      // 打印
      scope.print = () => {
        if (
          !scope.statisticTableData ||
          scope.statisticTableData.invoiceStatList.length < 1
        ) {
          logger.logError('未生成报表数据，不能打印')
        } else {
          $('#statisticsTable').jqprint({
            importCSS: true, // true表示引进原来的页面的css，默认是true。（如果是true，先会找$("link[media=print]")，若没有会去找$("link")中的css文件）
            printContainer: true, // 表示如果原来选择的对象必须被纳入打印（注意：设置为false可能会打破你的CSS规则）。
            operaSupport: true,
          })
        }
      }

      function getResponseStr(param) {
        $.jsonp({
          url: `${param.serverAddress}`,
          data: {
            SID: param.sid,
            SIDParam: param.sidReqParam,
          },
          timeout: 86400000,
          charset: 'GBK',
          callbackParameter: 'callback',
          success(json) {
            if (json.retcode === '1') {
              if (param.funcName === 'queryStatistics') {
                scope.queryStatistics({
                  responseStr: json.ResponseStr,
                  diskType: param.diskType,
                })
              }
            } else {
              logger.logError(json.retmsg)
              utils.loaded()
            }
          },
          error() {
            logger.logError('进项服务连接失败')
            utils.loaded()
          },
        })
      }
      // 统计查询
      scope.queryStatistics = ({
        responseStr,
        isShowLoading,
        diskType,
      } = {}) => {
        if (isShowLoading) {
          utils.loading('处理中')
        }
        let param = {
          month: scope.taxPeriod.replace(/\-/, ''),
        }
        if (responseStr) {
          param.responseStr = responseStr
        }
        if (diskType) {
          param.diskType = diskType
        }
        param.deviceType = inputDeviceType.deviceType
        httpRequest
          .get_ivatDrawbackCheck_invoiceStatQuery(param)
          .then((res) => {
            const result = res.data.value || {}
            if (!responseStr && result.diskType == '1') {
              getResponseStr({
                serverAddress: result.serverAddress,
                sid: result.sid,
                sidReqParam: result.sidReqParam,
                funcName: 'queryStatistics',
                diskType: result.diskType,
              })
            } else {
              scope.statisticTableData = result.response
              utils.loaded()
            }
          })
      }

      // 改变税款所属期
      scope.$watch('taxPeriod', (newVal, oldVal) => {
        if (newVal && newVal !== oldVal) {
          scope.taxPeriodName = scope.taxPeriod
            ? scope.taxPeriod.replace(/\-/, '年') + '月'
            : ''
          scope.queryStatistics({
            isShowLoading: true,
          })
        }
      })
    },
  }
}

statisticsDrawBack.$inject = [
  'httpRequest',
  'logger',
  '$timeout',
  'sweetalert',
  '$uibModal',
  'operationService',
]



// WEBPACK FOOTER //
// ./src/components/statisticsDrawBack/statisticsDrawBack.js